/**
 * Logout-on-refresh marker.
 *
 * The product requirement is that reloading the agent app ends the session —
 * the user must sign in again rather than silently re-entering. main.tsx sets
 * this flag (sessionStorage survives the reload it marks), and requireAuth
 * consumes it to skip the /auth/me cookie-based re-entry and go straight to
 * the login page. Consumed once — a normal navigation after the reload does
 * not keep forcing logouts.
 */
export const RELOAD_LOGOUT_KEY = 'kc3.reload-logout'

export function consumeReloadLogoutMarker(): boolean {
  try {
    const marked = sessionStorage.getItem(RELOAD_LOGOUT_KEY) === '1'
    if (marked) sessionStorage.removeItem(RELOAD_LOGOUT_KEY)
    return marked
  } catch {
    return false
  }
}
